export enum AuthTaskSortTypes {
    AuthType = 'Auth Type',
    BuyersName = 'Buyer\'s Name',
    NewestFirst = 'Newest First',
    OldestFirst = 'Oldest First',
    Risk = 'Risk'
}
